import React from 'react'
import { FormattedMessage } from 'react-intl'
import format from 'date-fns/format'
import { Tooltip } from 'antd'
import { ArrowRightIcon } from '../../../config/icons'

export const EmptyDate = ' -- '

export const renderTime = d => {
  try {
    if (d && d !== '') d = format(new Date(d), 'HH:mm')
  } catch (e) {
    console.log('invalid', `[${d}]`, e.message)
  }
  return d || EmptyDate
}

export const renderDate = d => {
  try {
    if (d && d !== '') d = format(new Date(d), 'dd/MM/yyyy')
  } catch (e) {
    console.log('invalid', `[${d}]`, e.message)
  }
  return d || EmptyDate
}

export const renderDateTime = d => {
  try {
    if (d && d !== '') d = format(new Date(d), 'dd/MM/yyyy HH:mm')
  } catch (e) {
    console.log('invalid', `[${d}]`, e.message)
  }
  return d || EmptyDate
}

export const renderDateTimeS = d => {
  try {
    if (d && d !== '') d = format(new Date(d), 'dd/MM/yyyy HH:mm:ss')
  } catch (e) {
    console.log('invalid', `[${d}]`, e.message)
  }
  return d || EmptyDate
}

export const renderUDate = d => {
  const timestamp = d * 1000
  if (timestamp < 1000) return ''
  try {
    if (d && d !== '') d = format(timestamp, 'dd/MM/yyyy')
  } catch (e) {
    console.log('invalid', `[${d}]`, e.message)
  }
  return d || EmptyDate
}

export const renderHistoryDate = d => {
  if (!d) return 'EmptyDate';
  try {
    const date = new Date(d);
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(date.getTime())) throw new Error('Invalid date');
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // I mesi sono indicizzati da 0
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  } catch (e) {
    console.log('invalid', `[${d}]`, e.message);
    return 'EmptyDate';
  }
}

export const renderUDateTime = d => {
  const timestamp = d * 1000
  if (timestamp < 1000) return ''
  try {
    if (d && d !== '') d = format(timestamp, 'dd/MM/yyyy HH:mm')
  } catch (e) {
    console.log('invalid', `[${d}]`, e.message)
  }
  return d || EmptyDate
}

export const ArrowDates = ({ start, end }) => {
  return (
    <div>
      {renderDate(start)} <ArrowRightIcon style={{ color: '#0096CC' }} /> {renderDate(end)}
    </div>
  )
}

export const sourceAge = (d, r) => {
  return (
    <div>
      <p>{r?.searchDocument?._source?.age}</p>
    </div>
  )
}

export const renderItemCode = d => (d ? d.label : '')

export const printName = d => (d ? d.name : '')

export const printFullName = d => (d ? d.fullName : '')

export const applyRenders = (columns, renders, getColumn = null ) =>
  columns.map(column => {

    if(getColumn) {
      column = getColumn(column)
    }

    const render = renders[column.dataIndex] || undefined

    const title = column.labelKey ? <FormattedMessage id={column.labelKey} /> : column.title

    return {
      ...column,
      title: column.finalTitle || title,
      render,
    }
  })
//  defaultMessage={column.title}

export const renderSurnameName = d => (d ? `${d.cognome} ${d.nome}` : '')
export const renderUserName = d => (d ? `${d.nome} ${d.cognome}` : '')

export const renderIsPublic = d => {
  if (d) {
    return <i className="fa fa-circle" style={{ color: '#097605', fontSize: 24 }} />
  }
  return <i className="fa fa-circle" style={{ color: '#CCCCCC', fontSize: 24 }} />
}

export const renderIsPublicAd = d => {
  if (d) {
    return (
      <Tooltip title={<FormattedMessage id={'progetti.ad_published'} />}>
        <i className="fa fa-circle" style={{ color: '#097605', fontSize: 24 }} />
      </Tooltip>
    )
  }
  return (
    <Tooltip title={<FormattedMessage id={'progetti.ad_not_published'} />}>
      <i className="fa fa-circle" style={{ color: '#CCCCCC', fontSize: 24 }} />
    </Tooltip>
  )
}
export const ColorCircle = ({ priority }) => {
  switch (priority) {
    case 65:
      return (
        <span>
          <i className={'fa fa-circle'} style={{ color: '#C70014' }} />
          <i className={'fa fa-circle'} style={{ color: '#C70014' }} />
          <i className={'fa fa-circle'} style={{ color: '#C70014' }} />
          <i className={'fa fa-circle'} style={{ color: '#C70014' }} />
        </span>
      )
    case 66:
      return (
        <span>
          <i className={'fa fa-circle'} style={{ color: '#DB5F00' }} />
          <i className={'fa fa-circle'} style={{ color: '#DB5F00' }} />
          <i className={'fa fa-circle'} style={{ color: '#DB5F00' }} />
          <i className={'fa fa-circle'} style={{ color: '#CCCCCC' }} />
        </span>
      )
    case 67:
      return (
        <span>
          <i className={'fa fa-circle'} style={{ color: '#0096CC' }} />
          <i className={'fa fa-circle'} style={{ color: '#0096CC' }} />
          <i className={'fa fa-circle'} style={{ color: '#CCCCCC' }} />
          <i className={'fa fa-circle'} style={{ color: '#CCCCCC' }} />
        </span>
      )
    case 68:
      return (
        <span>
          <i className={'fa fa-circle'} style={{ color: '#0A9106' }} />
          <i className={'fa fa-circle'} style={{ color: '#CCCCCC' }} />
          <i className={'fa fa-circle'} style={{ color: '#CCCCCC' }} />
          <i className={'fa fa-circle'} style={{ color: '#CCCCCC' }} />
        </span>
      )
    case 69:
      return (
        <span>
          <i className={'fa fa-circle'} style={{ color: '#CCCCCC' }} />
          <i className={'fa fa-circle'} style={{ color: '#CCCCCC' }} />
          <i className={'fa fa-circle'} style={{ color: '#CCCCCC' }} />
          <i className={'fa fa-circle'} style={{ color: '#CCCCCC' }} />
        </span>
      )
    case 1266:
      return (
        <span>
          <i className={'fa fa-circle'} style={{ color: '#0a9105' }} />
          <i className={'fa fa-circle'} style={{ color: '#cccccc' }} />
          <i className={'fa fa-circle'} style={{ color: '#cccccc' }} />
        </span>
      )
    case 1281:
      return (
        <span>
          <i className={'fa fa-circle'} style={{ color: '#1795cc' }} />
          <i className={'fa fa-circle'} style={{ color: '#1795cc' }} />
          <i className={'fa fa-circle'} style={{ color: '#cccccc' }} />
        </span>
      )
    case 1296:
      return (
        <span>
          <i className={'fa fa-circle'} style={{ color: '#db5f00' }} />
          <i className={'fa fa-circle'} style={{ color: '#db5f00' }} />
          <i className={'fa fa-circle'} style={{ color: '#db5f00' }} />
        </span>
      )

    default:
      return null
  }
}
